// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "statics/css/" + chunkId + "." + "153c6c2decd0b17fbef9" + ".css";
};